// initial state
// shape: [{id, description}]
const state = {
  clients: [],
  clientSelected: {}
}

function initialState() {
  return {
    clients: [],
    clientSelected: {}
  }
}

// getters
const getters = {
  clientSelectionDropDown: (state) => {
    return state.clients.map(({ id, description }) => {
      return {
        value: id,
        text: description
      }
    })
  }
}

// actions
const actions = {
  loadClientsAction({ commit, state }, clients) {
    commit('loadClients', clients)
  },
  setSelectedClientAction({ commit, state }, selectedClient) {
    commit('setSelectedClientMutation', selectedClient)
  },
  resetToInitialState({ commit }) {
    commit('reset')
  }
}

// mutations
const mutations = {
  loadClients(state, clients) {
    state.clients = clients
  },
  setSelectedClientMutation(state, selectedClient) {
    state.clientSelected = selectedClient
  },
  reset(state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
